<header class="header">
  <div class="logo">
    <picture>
      <!-- Desktop -->
      <source srcset="/logo_header-large.webp 1x, /logo_header-large@2x.webp 2x" media="(min-width: 768px)">
      <!-- Mobile -->
      <source srcset="/logo_header-small.webp 1x, /logo_header-small@2x.webp 2x" media="(max-width: 767px)">

      <!-- Fallback -->
      <img src="/logo_header-small.webp" alt="Ana Pellón" class="logo-header" />
    </picture>
    <span class="site-name">Ana Pellón Mendoza</span>
  </div>

  <!-- Menú escritorio -->
  <nav class="nav desktop-nav">
    <ul>
      <li>
        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Principal</a>
      </li>
      <li>
        <a routerLink="/sobre-mi" routerLinkActive="active">Sobre mí</a>
      </li>

      <!-- Dropdown Servicios -->
      <li class="dropdown">
        <a routerLink="/servicios" routerLinkActive="active">Servicios ▾</a>
        <ul class="dropdown-menu">
          <li><a routerLink="/servicios/terapia-infantil" routerLinkActive="active">Infancia</a></li>
          <li><a routerLink="/servicios/terapia-adolescentes" routerLinkActive="active">Adolescencia</a></li>
          <li><a routerLink="/servicios/terapia-adultos" routerLinkActive="active">Adultos</a></li>

          <li class="divider"></li>

          <li>
            <a routerLink="/servicios/preguntas-frecuentes" routerLinkActive="active">Preguntas Frecuentes</a>
          </li>
        </ul>
      </li>

      <li>
        <a routerLink="/espacio-de-trabajo" routerLinkActive="active">Espacio de trabajo</a>
      </li>
      <li>
        <a routerLink="/contacto" routerLinkActive="active">Contacto</a>
      </li>
    </ul>
    <a href="https://instagram.com/psico.anapellon" target="_blank"><img src="/icons/instagram-dark.svg"
        alt="Redes sociales" class="icon" /></a>
  </nav>

  <!-- Botón hamburguesa -->
  <button class="hamburger" (click)="toggleMenu()" aria-label="Abrir menú">
    <img src="/icons/hamburger.svg" alt="Menú" />
  </button>

  <!-- Overlay (oscurece fondo) -->
  @if (isMenuOpen) {
  <div class="overlay" (click)="closeMenu()" (keyup.enter)="closeMenu()" tabindex="0"></div>
  }

  <!-- Sidebar móvil -->
  <nav class="mobile-sidebar" [class.open]="isMenuOpen">
    <ul>
      <li>
        <a routerLink="/" (click)="closeMenu()" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">Principal</a>
      </li>
      <li>
        <a routerLink="/sobre-mi" (click)="closeMenu()" routerLinkActive="active">Sobre mí</a>
      </li>
      <li>
        <a class="menu-title" routerLink="/servicios" (click)="closeMenu()" (keyup.enter)="closeMenu()" tabindex="0"
          routerLinkActive="active">Servicios</a>
        <ul class="submenu">
          <li><a routerLink="/servicios/terapia-infantil" routerLinkActive="active" (click)="closeMenu()">Infancia</a>
          </li>
          <li><a routerLink="/servicios/terapia-adolescentes" routerLinkActive="active"
              (click)="closeMenu()">Adolescencia</a></li>
          <li><a routerLink="/servicios/terapia-adultos" routerLinkActive="active" (click)="closeMenu()">Adultos</a>
          </li>
          <li>
            <a routerLink="/servicios/preguntas-frecuentes" routerLinkActive="active" (click)="closeMenu()"
              class="faq-link">Preguntas Frecuentes</a>
          </li>
        </ul>
      </li>
      <li>
        <a routerLink="/espacio-de-trabajo" (click)="closeMenu()" routerLinkActive="active">Espacio de trabajo</a>
      </li>
      <li>
        <a routerLink="/contacto" (click)="closeMenu()" routerLinkActive="active">Contacto</a>
      </li>
    </ul>
    <a href="https://instagram.com/psico.anapellon" target="_blank"><img src="/icons/instagram-dark.svg"
        alt="Redes sociales" class="icon" /></a>
  </nav>
</header>